/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class FacetsController {
   $element: any
   $q: any
   $scope: any
   facets: any
   moreFacets: any
   constructor($scope: any, facets: any, moreFacets: any, $element: any, $q: any) {
      this.sortFacet = this.sortFacet.bind(this)
      this.getFacetClasses = this.getFacetClasses.bind(this)
      this.moreFacetValues = this.moreFacetValues.bind(this)
      this.toggleFacetValue = this.toggleFacetValue.bind(this)
      this.$scope = $scope
      this.facets = facets
      this.moreFacets = moreFacets
      this.$element = $element
      this.$q = $q
      this.$scope.facets                = this.facets.scope
      this.$scope.clearFacet            = this.facets.clear
      this.$scope.toggleCollapsed       = this.facets.toggleCollapsed
      this.$scope.sortFacet             = this.sortFacet
      this.$scope.getFacetClasses       = this.getFacetClasses
      this.$scope.moreFacetValues       = this.moreFacetValues
      this.$scope.toggleFacetValue      = this.toggleFacetValue
      this.$scope.triggerId             = null
   }

   sortFacet(facet: any, method: any) {
      return this.moreFacetValues(facet).finally(() => {
         this.facets.sortFacet(facet, method)
         return this.$element.find('#facetList' + facet.name).scrollTop(0)
      })
   }

   getFacetClasses(facet: any, count: any) {
      return this.facets.getFacetClasses(facet, count)
   }

   moreFacetValues(facet: any) {
      if (facet.moreLoaded) {
         return this.$q.resolve(true)
      }
      if (!facet.showmore) {
         return this.$q.resolve(false)
      }
      facet.moreFacetsLoading = true
      return this.moreFacets.getMoreFacets(facet).finally((res: any) => { 
         facet.moreFacetsLoading = false
         return facet.showSortLoader = false
      })
   }

   toggleFacetValue(...args: any[]) {
      const $event: JQueryEventObject = args.shift()
      $event?.preventDefault()
      // set triggerId to reset focus after results are returned
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      this.$scope.triggerId = document.activeElement.id
      return this.facets.toggle.apply(this, args)
   }
}

FacetsController.$inject = ['$scope', 'facetsService', 'moreFacetsService', '$element', '$q']

angular.module('summonApp.controllers')
   .controller('FacetsCtrl', FacetsController)
